<template>
  <div class="word" :class="`step-${currentStep}`">
    <transition-group name="fade">
      <span v-for="(singleWord, index) in presentedWordArray"
            v-bind:key="index"
            class="typing-word-holder">
        {{singleWord}}
      </span>
    </transition-group>
  </div>
</template>

<script>
  export default {
    name: 'LCStepWord',
    props: {
      currentStep: {
        type: Number,
        default: undefined
      }
    },
    data: function() {
      return {
        presentedWord: '',
        stepWords: {
          "1": "",
          "2": "hello",
          "3": "what",
          "4": "foundation",
          "5": "",
          "6": "",
          "7": "",
        }
      }
    },
    computed: {
      word() {
        return this.stepWords[this.currentStep.toString()]
      },
      presentedWordArray() {
        return this.presentedWord.split('')
      }
    },
    watch: {
      word() {
        this.presentedWord = ""
        setTimeout(() => {
          const speed = 700 / this.word.length
          this.typeWriter(speed)
        }, 1000);
      }
    },
    methods: {
      typeWriter(speed) {
        if (this.presentedWord.length < this.word.length) {
          this.presentedWord += this.word.charAt(this.presentedWord.length);
          setTimeout(() => this.typeWriter(speed), speed);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.word {
  position: fixed;
  bottom: 34px;
  left: -7%;
  font-size: 180px;
  font-weight: bold;
  color: #FFD1AD;
  opacity: 0.1;
  line-height: 226.25px;
  mix-blend-mode: overlay;
  width: 130%;
  max-width: 140%;
  word-break: break-all;
  transition: all .25s ease;

  @media screen and (min-width: $tablet) {
    font-size: 250px;
    bottom: 55px;
    left: 14%;
    width: auto;
    max-width: 55%;
  }

  &.step-3 {
    left: -5%;

    @media screen and (min-width: $tablet) {
      left: 10%;
    }
  }

  &.step-4 {
    bottom: 0px;
  }
}

.typing-word-holder {
  display: inline-block;
}
</style>
